import { useCallback } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { logError } from 'utils/logger';
import { invoiceApi } from '../api';
import { UpdateInvoiceResponse, UpdateInvoiceVariables } from '../api/types';
import { collectInvoiceFromVO } from '../lib';

export function useInvoice() {
  const [fetchInvoice] = useLazyQuery(invoiceApi.getByID);

  const [updateInvoice, { loading }] = useMutation<UpdateInvoiceResponse, Partial<UpdateInvoiceVariables>>(
    invoiceApi.update
  );

  const handleFetchInvoice = async (id: string) => {
    try {
      const { data } = await fetchInvoice({ variables: { id } });

      if (!data?.invoice) return null;

      return collectInvoiceFromVO(data.invoice)!;
    } catch (error) {
      logError(error);
      return null;
    }
  };

  const handleUpdateInvoice = useCallback(
    async (variables: Partial<UpdateInvoiceVariables>) => {
      try {
        await updateInvoice({ variables });
      } catch (error) {
        logError(error);
      }
    },
    [updateInvoice]
  );

  return {
    handleFetchInvoice,
    handleUpdateInvoice,
    isInvoiceUpdating: loading,
  };
}
